import { useCallback, useMemo } from 'react';
import { useAppStore } from '../store';

const ONBOARDING_COMPLETE_KEY = 'onboardingComplete';

export function useOnboarding() {
  const transactions = useAppStore((state) => state.transactions);
  const isInitialized = useAppStore((state) => state.isInitialized);

  const isOnboardingComplete = useMemo(() => {
    return localStorage.getItem(ONBOARDING_COMPLETE_KEY) === 'true';
  }, []);

  const isFirstTimeUser = useMemo(() => {
    if (!isInitialized) return false;
    return transactions.length === 0 && !isOnboardingComplete;
  }, [isInitialized, transactions.length, isOnboardingComplete]);

  const completeOnboarding = useCallback(() => {
    localStorage.setItem(ONBOARDING_COMPLETE_KEY, 'true');
  }, []);

  const resetOnboarding = useCallback(() => {
    localStorage.removeItem(ONBOARDING_COMPLETE_KEY);
  }, []);

  return {
    isFirstTimeUser,
    isOnboardingComplete,
    isInitialized,
    completeOnboarding,
    resetOnboarding,
  };
}
